<div class="mb-3" [ngClass]="{ 'd-block': visible, 'd-none': !visible, transparent: transparent }"></div>
